import queryString from 'query-string'
import { usingGet, EMPTY_SUCCESS_RESPONSE } from '@ocean/api'
import { FilterUtils } from '@ocean/utils'
import { ElearningCategoryFilterItems } from 'modules/trainingLibrary/Elearning/types'

export const getElearning = () => usingGet('Search/Library/Elearnings', { useProxy: true })

export const getElearningCategory = (
  categoryId: Guid,
  externalFilters: ElearningCategoryFilterItems
) => {
  const filterValues = FilterUtils.getExternalFilterValues(externalFilters)
  if (FilterUtils.findEmptyFilter(filterValues)) return EMPTY_SUCCESS_RESPONSE
  const queryParams = queryString.stringify(filterValues, { skipNull: true })
  return usingGet(`Search/Library/Category/${categoryId}?${queryParams}`, { useProxy: true })
}
